// @ts-strict-ignore
import React from 'react'
import Content from '../content'
import HeaderPlaceholder from './HeaderPlaceholder'
import StoryContentPlaceholder from './StoryContent'
import classnames from 'classnames'
interface DefaultPagePlaceholderProps {
	isTourPage?: boolean
}

const DefaultPagePlaceholder: React.FC<DefaultPagePlaceholderProps> = ({ isTourPage }) => (
	<div className="ion-page" style={isTourPage ? null : { background: 'var(--background-color)' }}>
		<Content className={classnames('page-content default-page', { 'default-page--tour': isTourPage })}>
			<HeaderPlaceholder />
			<StoryContentPlaceholder style={{ padding: '0 24px' }} />
		</Content>
	</div>
)

export default DefaultPagePlaceholder
